import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { map } from 'rxjs';

import { UnsavedChangesDialogComponent } from '../shared/unsaved-changes-dialog/unsaved-changes-dialog.component';

export interface HasUnsavedChanges {
  hasUnsavedChanges(): boolean;
}

/**
 * Asks the user to confirm before leaving a route whose component reports unsaved changes.
 * Covers in-app navigation (links, Cancel buttons, browser/swipe back). Full page unloads
 * (refresh, close tab) are handled separately via a beforeunload listener on each component.
 */
export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = (component) => {
  const dialog = inject(MatDialog);

  if (!component.hasUnsavedChanges()) {
    return true;
  }

  return dialog
    .open<UnsavedChangesDialogComponent, void, boolean>(UnsavedChangesDialogComponent, { disableClose: true })
    .afterClosed()
    .pipe(map(leave => leave === true));
};
